import React, { useState, useEffect } from "react";
import ExistingPlans from "./ExistingPlans";
import AddNewPlan from "./AddNewPlan";
import { useSelector } from "react-redux";
import Box from "../../../../../components/Box";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
const INITIAL_STATE_SCREEN = "initial";
const ADD_STATE_SCREEN = "add";

const PlanTab = () => {
  const [selectedSegment, setselectedSegment] = useState("Information");
  const [showComponent, setShowComponent] = useState("initial");
  const [showEdit, setShowEdit] = useState(false)
  const activeEntity = useSelector((state) => state.adminReducer.activeEntity);
  const userType = localStorage.getItem('user_type')
  const {t} = useTranslation()
  const setSegment = (segment) => {
    setselectedSegment(segment);
  };

  const pathName = window.location.search;
  

  useEffect(() => {
    if (pathName === "?new") {
      setselectedSegment("Screen details");
    }
  }, [pathName]);

  const renderSegment = () => {
      if (showEdit) {
          return (
              <Box display="flex">
                  <Box cursor="pointer" onClick={() => {
                    setShowEdit(false)
                    window.location.href = `/users/subscriptions`
                  }}>{t('Membership')}</Box>&nbsp; &nbsp; <span style={{color:'#7e7e7e'}}>&gt; &nbsp;{t('Edit Plan')}</span>
              </Box>
          );
      } else {
          return t("Membership")
      }
  }

  return (
    <div>
      <Box display="flex" alignItems="center" cursor="pointer" justifyContent="space-between" paddingLeft="1.1rem" paddingRight="1.1rem">
        <Box fontSize="22px" fontWeight={700}>{selectedSegment === "Information" ? renderSegment() : t("Add New Membership")}</Box>
        <ul className="d-flex plan-modal ">
          <li
            className="information col-6 d-flex justify-content-center align-items-center"
            style={{
              fontWeight: selectedSegment === "Information" ? "600" : "600",
              backgroundColor:
                selectedSegment === "Information" ? "#D0004B" : "#fff",
              color: selectedSegment === "Information" ? "#fff" : "#D0004B",
              borderRadius:
                selectedSegment === "Information"
                  ? "50px 0px 0px 50px"
                  : "50px 0px 0px 50px",
            }}
            onClick={() => setSegment("Information")}
          >
            {t('Existing Memberships')}{" "}
          </li>
          <li
            className="screen-details col-6 pt-2"
            style={{
              fontWeight: selectedSegment === "Screen details" ? "600" : "600",
              backgroundColor:
                selectedSegment === "Screen details" ? "#D0004B" : "#fff",
              color: selectedSegment === "Screen details" ? "#fff" : "#D0004B",
              borderRadius:
                selectedSegment === "Screen details"
                  ? "0px 50px 50px 0px"
                  : "0px 50px 50px 0px",
              pointerEvents: userType === 'viewer'?'none':''    
            }}
            onClick={() => setSegment("Screen details")}
          >
            {t('New Membership')} <br/>{t('Add')}{" "}
          </li>
        </ul>
      </Box>
      <Box mt="25px">
        {selectedSegment === "Information" ? (
         <ExistingPlans
           showComponent={showComponent}
           setShowComponent={setShowComponent}
           setShowEdit={setShowEdit}
           setSegment={setSegment} />
          // <EditPlan setSegment={setSegment}/>
        ) : null}
        {selectedSegment === "Screen details" ? (
          <AddNewPlan setSegment={setSegment} />
        ) : null}
      </Box>
    </div>
  );
}

export default PlanTab;
